export default __webpack_public_path__ + "static/media/42_fire.51739e14.JPG";